import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import SignUp    from './pages/SignUp';
import Confirm   from './pages/Confirm';
import Login     from './pages/Login';
import Home      from './pages/Home';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { RoleProvider } from './context/RoleContext';
import { AlertProvider, useAlert } from './context/AlertContext';
import setupAxiosInterceptor, { setAlertFunction } from './utils/axiosInterceptor';

// Component to set up axios interceptor with alert function
const AxiosSetup = () => {
  const { showError } = useAlert();

  useEffect(() => {
    // Set up the alert function for axios interceptor
    setAlertFunction(showError);

    // Set up global axios interceptor for token expiration handling
    setupAxiosInterceptor();
  }, [showError]);

  return null;
};

function App() {
  return (
    <RoleProvider>
      <AlertProvider>
        <AxiosSetup />
        <HashRouter>
          <Routes>
            <Route path="/signup"   element={<SignUp />} />
            <Route path="/confirm"  element={<Confirm />} />
            <Route path="/login"    element={<Login />} />
            <Route path="/home"     element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </HashRouter>
      </AlertProvider>
    </RoleProvider>
  );
}

export default App;
